import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../aiss-sso.constants';

@Component({
  selector: 'app-aiss-sso-change-password-sent',
  templateUrl: './aiss-sso-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './aiss-sso-change-password-sent.component.css',
  ],
})
export class HicreaSsoChangePasswordSentComponent implements OnInit {
  email: string;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void { }
}
